import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "product-details-content" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "top" }
const _hoisted_4 = { class: "product-details-box pc" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = { class: "swiper-vertical-box" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "middle" }
const _hoisted_10 = { class: "right" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "describe" }
const _hoisted_13 = { class: "phone" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "right" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "describe" }
const _hoisted_19 = { class: "bottom" }
const _hoisted_20 = { class: "title" }
const _hoisted_21 = ["innerHTML"]

import { useRoute } from 'vue-router'
import NavBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'
import { UtilMethods } from '@/util/UtilMethods'
import Breadcrumb from '@/components/Breadcrumb.vue'
import { BreadType } from '@/typeDefine/EntityType'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation, Pagination } from 'swiper/modules'
import { Ref, ref, reactive, computed, onMounted } from 'vue'
import { ArrowUp, ArrowDown } from '@element-plus/icons-vue'
import { Action } from '@/typeDefine/CommonTypes'
import { Api } from '@/http/Api'
import { GetProductDetailsByIdResponse } from '@/typeDefine/HttpResponseType'
import { ResponseCode } from '@/http/ResponseCode'
import { ConstantField } from '@/constant/ConstantField'

const lensWidth = 150
const lensHeight = 150

// 放大倍数
const zoomScale = 3


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductDetails',
  setup(__props) {

const maxZIndex: string = UtilMethods.getDOMStyleFromCSS('--max-z-index')
const route = useRoute()
const prevRef = ref<HTMLElement | null>(null)
const nextRef = ref<HTMLElement | null>(null)
const middleRef = ref<HTMLElement | null>(null)
const mainImageRef = ref<HTMLElement | null>(null)
const showZoom = ref(false)
// 镜头位置
const lensPos = reactive({ x: 0, y: 0 })

// 镜头尺寸
let animationFrameId: number | null = null

const breadList: BreadType[] = [
    {
        to: '/products',
        text: 'index.navBar.product'
    },
    {
        text: 'index.navBar.productDetails'
    }
]

const details: Ref<GetProductDetailsByIdResponse['data']['details']> = ref({
    name: '',
    typeId: 0,
    id: 0,
    images: [],
    content: '',
    cover: '',
    describeText: '',
    hot: 0,
})

onMounted(() => {
    if (route.params.id && typeof route.params.id === 'string') {
        requestProductDetails(Number.parseInt(route.params.id))
    }
})

const requestProductDetails: Action<[number]> = async (id: number) => {
    const resonse: GetProductDetailsByIdResponse = await Api.instance.getProductDetailsById({
        id
    })

    UtilMethods.showMessageToast(resonse, false)

    if (resonse.code === ResponseCode.OK) {
        details.value = resonse.data.details

        details.value.images.unshift({
            id: 0,
            path: details.value.cover,
            productId: 0
        })
    }
}

// 计算镜头样式
const lensStyle = computed(() => ({
    width: `${lensWidth}px`,
    height: `${lensHeight}px`,
    top: `${lensPos.y}px`,
    left: `${lensPos.x}px`,
}))

// 计算放大镜显示样式
const zoomStyle = computed(() => ({
    width: `${lensWidth * zoomScale}px`,
    height: `${lensHeight * zoomScale}px`,
    backgroundImage: `url(${details.value.cover})`,
    backgroundRepeat: 'no-repeat',
    // 背景图放大尺寸
    backgroundSize: `${500 * zoomScale}px ${500 * zoomScale}px`,
    // 背景图位置（反向移动镜头位置）
    backgroundPosition: `-${lensPos.x * zoomScale}px -${lensPos.y * zoomScale}px`,
}))

// 鼠标进入显示放大镜
function handleMouseEnter() {
    showZoom.value = true
}

// 鼠标离开隐藏放大镜
function handleMouseLeave() {
    showZoom.value = false
}

// 鼠标移动更新镜头位置
function handleMouseMove(event: MouseEvent) {
    if (!middleRef.value) return

    if (animationFrameId) {
        cancelAnimationFrame(animationFrameId)
    }

    animationFrameId = requestAnimationFrame(() => {
        const rect = middleRef.value!.getBoundingClientRect()

        let x = event.clientX - rect.left - lensWidth / 2
        let y = event.clientY - rect.top - lensHeight / 2

        x = Math.max(0, Math.min(x, rect.width - lensWidth))
        y = Math.max(0, Math.min(y, rect.height - lensHeight))

        lensPos.x = x
        lensPos.y = y
    })
}

const handleClickSmallImages: Action<[string]> = (src) => {
    details.value.cover = `${src}`
}

return (_ctx: any,_cache: any) => {
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_affix, { "z-index": _unref(maxZIndex) }, {
      default: _withCtx(() => [
        _createVNode(NavBar)
      ]),
      _: 1
    }, 8, ["z-index"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Breadcrumb, { "bread-list": breadList }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                ref_key: "prevRef",
                ref: prevRef,
                class: "swiper-button-prev-custom pointer-cursor"
              }, [
                _createVNode(_component_el_icon, { size: "30" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ArrowUp))
                  ]),
                  _: 1
                })
              ], 512),
              _createVNode(_unref(Swiper), {
                direction: "vertical",
                "slides-per-view": 4,
                loop: "",
                modules: [_unref(Navigation)],
                pagination: { clickable: true, el: '.swiper-pagination' },
                navigation: { prevEl: prevRef.value, nextEl: nextRef.value },
                class: "swiper-content-pc"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(details.value.images, (img, index) => {
                    return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                      key: index,
                      class: "swiper-slide"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "swiper-item-pc pointer-cursor",
                          onClick: ($event: any) => (handleClickSmallImages(img.path))
                        }, [
                          _createElementVNode("img", {
                            src: `${img.path}`,
                            class: "slide-img"
                          }, null, 8, _hoisted_8)
                        ], 8, _hoisted_7)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "swiper-pagination" }, null, -1))
                ]),
                _: 1,
                __: [0]
              }, 8, ["modules", "navigation"]),
              _createElementVNode("div", {
                ref_key: "nextRef",
                ref: nextRef,
                class: "swiper-button-next-custom pointer-cursor"
              }, [
                _createVNode(_component_el_icon, { size: "30" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ArrowDown))
                  ]),
                  _: 1
                })
              ], 512)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "",
              ref_key: "middleRef",
              ref: middleRef
            }, [
              _createVNode(_component_el_image, {
                style: {"width":"500px","height":"500px"},
                src: `${details.value.cover}`,
                ref_key: "mainImageRef",
                ref: mainImageRef,
                onMousemove: handleMouseMove,
                onMouseenter: handleMouseEnter,
                onMouseleave: handleMouseLeave
              }, null, 8, ["src"])
            ], 512),
            (showZoom.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "zoom-lens",
                  style: _normalizeStyle(lensStyle.value)
                }, null, 4))
              : _createCommentVNode("", true),
            (showZoom.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "zoom-result",
                  style: _normalizeStyle(zoomStyle.value)
                }, null, 4))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(details.value.name), 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(details.value.describeText), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_unref(Swiper), {
            loop: "",
            modules: [_unref(Navigation), _unref(Pagination)],
            pagination: { clickable: true, el: '.swiper-pagination' },
            navigation: { prevEl: prevRef.value, nextEl: nextRef.value },
            class: "swiper-content-phone"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(details.value.images, (img, index) => {
                return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                  key: index,
                  class: "swiper-slide"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "swiper-item-phone pointer-cursor",
                      onClick: ($event: any) => (handleClickSmallImages(img.path))
                    }, [
                      _createElementVNode("img", {
                        src: `${img.path}`,
                        class: "slide-img"
                      }, null, 8, _hoisted_15)
                    ], 8, _hoisted_14)
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "swiper-pagination" }, null, -1))
            ]),
            _: 1,
            __: [1]
          }, 8, ["modules", "navigation"]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(details.value.name), 1),
            _createElementVNode("div", _hoisted_18, _toDisplayString(details.value.describeText), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('products.describe')), 1),
        _createElementVNode("div", {
          class: "content",
          innerHTML: details.value.content
        }, null, 8, _hoisted_21)
      ])
    ]),
    _createVNode(Footer)
  ]))
}
}

})